module.exports = __webpack_public_path__ + "img/illustration-register-v2-light.5ee63d1c.png";